import { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import { Formik, Form, ErrorMessage } from "formik";
import Button from "../../../atoms/buttons/Button";
import Modal from "react-bootstrap/Modal";
import "./consultaIRPF.scss";
import { memo } from "react";
import React, { useState, useEffect } from "react";
import Select from "react-select";
import {
  SpinnerCircle,
  SpinnerCircleMini,
} from "../../../atoms/spinner/Spinner";
import { getYears } from "../../../services/IRPFService";
import SubTituloResMini from "../../../atoms/subTitles/SubTituloResMini";
import { useLocalStorage } from "../../../../hooks/useLocalStorage";
import ButtonCard from "../../../atoms/buttons/ButtonCard";
import { useNavigate } from "react-router-dom";

registerLocale("es", es);

const ConsultaIRPF = (object) => {
  const navigate = useNavigate();
  const [token] = useLocalStorage("token", "");
  const [loading, setLoading] = useState(false);
  const [loadingButton, setLoadingButton] = useState(true);
  const [years, setYears] = useState([]);
  // const [setYearSelect] = useState(0);

  const [showFeedback, setShowFeedback] = useState(false);
  const [isInitialRender, setIsInitialRender] = useState(false);
  // const [user] = useLocalStorage("token", "");

  // const handleChangeYear = (e) => {
  //   if (e !== null) {
  //     setYearSelect(e.value);
  //   } else {
  //     setYearSelect(null);
  //   }
  // };

  useEffect(() => {
    if (!isInitialRender) {
      setIsInitialRender(true);
      getYears(token).then((data) => {
        let anyos = data.filter(item => item.value > 2008);

        setYears(anyos);
        if (!data.toString().startsWith("Error:")) {
          setLoading(true);

          // Establece el primer año de la lista como valor predeterminado en yearSelect
          // if (anyos.length > 0) {
          //   setYearSelect(anyos[0].value); // Asignar primer valor de `years` al `yearSelect`
          // }
        }
      });
    }
  }, [isInitialRender, token, years]);

  function modalConsultaIRPF() {
    return (
      <Modal
        className="infModal fechas"
        show={object.show}
        onHide={object.handleClose}
        backdrop="static"
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {/* <Titulo titulo={"Consulta IRPF"} tipo={"tituloModal"} /> */}
            <h4 className="tituloModal">Consulta IRPF</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="caja_formulario col-xxl-12 col-xl-12 col-lg-12 cold-md-12 cold-sm-12">
            <Formik
              enableReinitialize={true}
              initialValues={{
                year: years[0]?.value ?? null
              }}

              validate={(values) => {
                const errors = {};
                if (!values.year) {
                  errors.year = "Por favor, seleccione un año";
                }
                return errors;
              }}
              onSubmit={(values) => {
                setLoadingButton(false);
                setLoadingButton(true);
                setShowFeedback(false);

                localStorage.setItem(
                  "datosIrpfSelect",
                  JSON.stringify({ anyo: values.year })
                );

                navigate("/irpfPDF", { state: { year: values.year } });
                object.handleClose();
              }}
            >
              {({ errors, setFieldValue, values }) => (
                <>
                  <Form>
                    <div className="container">
                      <div className="row align-items-start">
                        {loading ? (
                          <>
                            <div className="row col-xl-9 pb-xl-4">
                              <label htmlFor="year">
                                <SubTituloResMini nombre="Año" />
                              </label>

                              <Select
                                id="year"
                                name="year"
                                options={years}
                                className="selectYear"
                                placeholder="Año"
                                isClearable
                                // value={
                                //   years.find((option) => option.value === values.year) ||
                                //   null
                                // }
                                defaultValue={years[0]}
                                onChange={(option) => {
                                  setFieldValue("year", option ? option.value : null); // ✔ Formik actualiza
                                  setShowFeedback(false); // ✔ Ocultar feedback custom
                                }}
                              />

                              {showFeedback && (
                                <div className="error rojo fs-4 pt-2">
                                  {`Actualmente no están cargados en el sistema los datos del Certificado del año ${values.year} que se desea consultar.`}
                                </div>
                              )}

                              <ErrorMessage
                                name="year"
                                component={() => (
                                  <div className="error rojo fs-4 pt-2">
                                    {errors.year}
                                  </div>
                                )}
                              />
                            </div>

                            <div className="row pt-3 col-xxl-2 col-xl-2 col-lg-2 col-md-12 col-sm-12">
                              <div className="col ms-xl-3 pt-3 pb-4">
                                <ButtonCard
                                  id="consultaIRPF"
                                  clases="btn-card rounded"
                                  nombre={
                                    loadingButton ? (
                                      <>
                                        <i className="fa-solid fa-eye"></i> Consultar
                                      </>
                                    ) : (
                                      <div className="d-flex justify-content-center">
                                        <SpinnerCircleMini clases={"background-border"} />
                                      </div>
                                    )
                                  }
                                  tipo="submit"
                                  disabled={!loadingButton}
                                />
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            <span>
                              {years.length === 0 ? <SpinnerCircle /> : null}
                            </span>
                            <div className="error rojo fs-4 pt-2">
                              {years !== undefined ? years : null}
                            </div>
                            {years.length !== 0 && (
                              <div className="row justify-content-center pt-3">
                                <Button
                                  id="btnCerrarConsultaIRPF"
                                  clases="btn-card"
                                  nombre="Cerrar"
                                  tipo="button"
                                  funcion={() => {
                                    object.handleClose();
                                  }}
                                />
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </Form>
                </>
              )}
            </Formik>

          </div>
        </Modal.Body>
      </Modal>
    );
  }

  return <>{modalConsultaIRPF()}</>;
};

export default memo(ConsultaIRPF);
